/* Chat with Erik Rawles (09-26, hero setting "Chat with Erik Rawles"): canned flows, no AI, no typing. The presence
   dot by his name opens the conversation window (snippets/erik-chat.liquid); each turn offers the replies of the
   current <template>, Erik answers line by line after "is typing a message", and a thread that offers nothing more
   ends with him going Busy (the dot turns red, the window keeps the log until the page reloads). Esc or the X closes
   the window and gives focus back to his name; the window never blocks the page, so the email works as before. */
(function () {
  'use strict';
  var box = document.querySelector('[data-erik]');
  if (!box || !Element.prototype.closest) { return; }
  var log = box.querySelector('[data-erik-log]');
  var replies = box.querySelector('[data-erik-replies]');
  var status = box.querySelector('[data-erik-status]');
  var started = false;
  var busy = false;
  var opener = null;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function node(id) { return box.querySelector('template[data-erik-node="' + id + '"]'); }
  function scroll() { log.scrollTop = log.scrollHeight; }

  function say(who, lines, mine) {
    var block = document.createElement('div');
    block.className = 'im__block' + (mine ? ' im__block--me' : '');
    var head = document.createElement('p');
    head.className = 'im__who';
    head.textContent = who;
    block.appendChild(head);
    for (var i = 0; i < lines.length; i++) { block.appendChild(lines[i]); }
    log.appendChild(block);
    scroll();
    return block;
  }

  function offer(id) {
    replies.innerHTML = '';
    var t = node(id);
    var buttons = t ? t.content.querySelectorAll('button') : [];
    for (var i = 0; i < buttons.length; i++) { replies.appendChild(buttons[i].cloneNode(true)); }
    if (!buttons.length) { end(); return; }
    if (box.contains(document.activeElement) || document.activeElement === document.body) {
      var first = replies.querySelector('button');
      if (first) { first.focus({ preventScroll: true }); }
    }
  }

  function end() {
    busy = true;
    var note = document.createElement('p');
    note.className = 'im__system';
    note.textContent = box.getAttribute('data-busy');
    log.appendChild(note);
    scroll();
    status.textContent = box.getAttribute('data-busy-note');
    var dots = document.querySelectorAll('.presence__dot');
    for (var i = 0; i < dots.length; i++) { dots[i].classList.add('is-busy'); }
    var close = box.querySelector('[data-erik-close]');
    if (close && (box.contains(document.activeElement) || document.activeElement === document.body)) { close.focus({ preventScroll: true }); }
  }

  function answer(id) {
    var t = node(id);
    var lines = t ? t.content.querySelectorAll('.im__msg') : [];
    var block = null;
    var i = 0;
    function next() {
      if (i >= lines.length) {
        status.textContent = status.getAttribute('data-last');
        offer(id);
        return;
      }
      var line = lines[i].cloneNode(true);
      var wait = Math.min(1800, 450 + 26 * line.textContent.length);
      status.textContent = box.getAttribute('data-typing');
      box.classList.add('is-typing');
      window.setTimeout(function () {
        box.classList.remove('is-typing');
        if (!block) { block = say(box.getAttribute('data-erik-says'), [line], false); } else { block.appendChild(line); scroll(); }
        i += 1;
        next();
      }, reduce ? Math.min(wait, 700) : wait);
    }
    window.setTimeout(next, 350);
  }

  function open(from) {
    opener = from || null;
    box.hidden = false;
    if (!started) { started = true; offer('start'); }
    var target = replies.querySelector('button') || box.querySelector('[data-erik-close]');
    if (target) { target.focus({ preventScroll: true }); }
  }

  function close() {
    box.hidden = true;
    if (opener && document.body.contains(opener)) { opener.focus({ preventScroll: true }); }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-erik-open]');
    if (trigger) {
      event.preventDefault();
      if (box.hidden) { open(trigger); } else { close(); }
    }
  });
  box.addEventListener('click', function (event) {
    if (event.target.closest('[data-erik-close]')) { close(); return; }
    var reply = event.target.closest('.im__reply');
    if (!reply || busy) { return; }
    var mine = document.createElement('p');
    mine.className = 'im__msg';
    mine.textContent = reply.textContent;
    say(box.getAttribute('data-you'), [mine], true);
    replies.innerHTML = '';
    answer(reply.getAttribute('data-next'));
  });
  box.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.stopPropagation();
      close();
    }
  });
})();
